import { toQuery } from '@debbie/common/dist/util/index.js';
import { IAM } from '../apis.js';
const reqCreditorUsers = IAM('/creditor-users');
export const getByCreditorId = (creditorId) => reqCreditorUsers('GET', `/?${toQuery({ creditorId })}`);
export const invite = (creditorId, newUser) => reqCreditorUsers('POST', `/?${toQuery({ creditorId })}`, {
    body: newUser,
});
//# sourceMappingURL=creditor-users.js.map